import React, { useEffect, useState } from "react";
import smallAvatar1 from "../assets/images/small-avtar-1.png";
import smallAvatar2 from "../assets/images/small-avtar-2.png";
import students from "../assets/images/students.png";
import green from "../assets/images/green.png";
import book from "../assets/images/book.png";
import red from "../assets/images/red.png";
import audioBook from "../assets/images/audio-book.png";
import moneyDollar from "../assets/images/money-dollar.png";
import logout from "../assets/images/logout-modal.png";
import { useDispatch } from "react-redux";
import { getDashboardData } from "../features/slices/dashboard";
import { useSelector } from "react-redux";
const initialState = {
  fromDate: "",
  toDate: "",
  timeframe: "",
};
const Dashboard = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { fromDate, timeframe, toDate } = iState;
  const [data, setData] = useState({});

  const dispatch = useDispatch();
  const {dashboardData}=useSelector(state=>{
    return state.dashboard;
  })
  console.log({ dashboardData });
  
  useEffect(() => {
    dispatch(getDashboardData({ timeframe })).then((res) => {
      setData(res.payload);
    });
  }, [timeframe]);
  const handleChange = (e) => {
    setUpdateState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleApply = () => {
    const data = {
      startDate: fromDate,
      endDate:toDate,
    };
    dispatch(getDashboardData(data))
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getDashboardData());
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From</label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  value={fromDate}
                  disabled={timeframe}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>To</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  onChange={handleChange}
                  disabled={timeframe}
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button" onClick={handleApply}>
                  Apply
                </button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control"
                  name="timeframe"
                  onChange={handleChange}
                  value={timeframe}
                  disabled={fromDate || toDate}
                >
                  <option>Select </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
              <button className="Button Cancel ml-2" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
            </div>
            <div className="FilterRight"></div>
          </div>
          <div className="TitleBox">
            <h4 className="Title">Student</h4>
          </div>
          <div className="DashboardBox">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Students</p>
                    {/* <div className="AvatarGroup">
                      <span className="Avatar">
                        <img src={smallAvatar1} />
                      </span>
                      <span className="Avatar">
                        <img src={smallAvatar2} />
                      </span>
                      <span className="Avatar">
                        <img src={smallAvatar2} />
                      </span>
                    </div> */}
                  </aside>
                  <aside>
                    <span className="Icon Blue">
                      <img src={students} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalUsers}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +12.05%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
          <div className="TitleBox">
            <h4 className="Title">Courses</h4>
          </div>
          <div className="DashboardBox">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Courses</p>
                    {/* <div className="AvatarGroup">
                      <span className="Avatar">
                        <img src={smallAvatar1} />
                      </span>
                      <span className="Avatar">
                        <img src={smallAvatar2} />
                      </span>
                      <span className="Avatar">
                        <img src={smallAvatar2} />
                      </span>
                    </div> */}
                  </aside>
                  <aside>
                    <span className="Icon Blue">
                      <img src={book} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalCourse}
                      </h3>
                      {/* <p className="Red">
                        <span>
                          <img src={red} />
                        </span>
                        -12.25%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Enrollment in Various Courses</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={audioBook} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalEnroleCourse}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
          <div className="TitleBox">
            <h4 className="Title">Podcasts</h4>
          </div>
          <div className="DashboardBox">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Podcast</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalPodcast}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Podcasts Saved</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalPodcastEngaged}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
          <div className="TitleBox">
            <h4 className="Title">Challenges</h4>
          </div>
          <div className="DashboardBox">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Challenges</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalChallenges}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Upcoming Challenges</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalUpcomingChallenges}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Ongoing Challenges</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalOngoingChallenges}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Completed Challenges</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalCompletedChallenges}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
          <div className="TitleBox">
            <h4 className="Title">Live Streams</h4>
          </div>
          <div className="DashboardBox">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Livestreams</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalLiveStream}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Upcoming Live streams</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalUpcomingLiveStream}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Ongoing Live streams</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalOngoingLiveStream}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Completed Live streams</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDollar} />
                    </span>
                    <figcaption>
                      <h3
                        style={{
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {dashboardData?.totalCompletedLiveStream}
                      </h3>
                      {/* <p className="Green">
                        <span>
                          <img src={green} />
                        </span>
                        +25.21%
                      </p> */}
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="ModalBox">
        <div id="LogOutModal" className="modal fade SmallModal" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Category">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <div className="LogOutArea">
                    <figure>
                      <img src={logout} />
                    </figure>
                    <h4>Logout</h4>
                    <p>Are you sure want to logout.</p>
                    <div className="LogOutButton">
                      <button className="Button Outline" data-dismiss="modal">
                        No
                      </button>
                      <button className="Button Red" id="Login">
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="loom-companion-mv3" ext-id="liecbddmkiiihnedobmlmillhodjkdmb">
        <section id="shadow-host-companion" />
      </div>
    </>
  );
};

export default Dashboard;
